"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createBrowserRouter = createBrowserRouter;
var _reactRouter = require("react-router");
var _config = _interopRequireDefault(require("../config"));
var _getShellRoutes = require("./getShellRoutes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function createBrowserRouter(routes, opts) {
  var _config$nui = _config.default.nui,
    useAnonymousErrorRoutes = _config$nui.use_anonymous_error_routes,
    baseUrl = _config$nui.baseUrl;
  var routesResult = typeof routes === 'function' ? routes() : routes;
  var consumerRoutesArray = Array.isArray(routesResult) ? routesResult : (0, _reactRouter.createRoutesFromChildren)(routesResult);

  // base url will be defined via opts  when calling createBrowserRouter
  var shellRoutesArray = (0, _getShellRoutes.getShellRoutesArray)(opts !== null && opts !== void 0 && opts.basename ? '' : baseUrl, useAnonymousErrorRoutes);

  // This function is a placeholder for the real implementation
  return (0, _reactRouter.createBrowserRouter)([].concat(_toConsumableArray(consumerRoutesArray), _toConsumableArray(shellRoutesArray)), opts);
}